import type { AppThunk } from "@Store/index";
import { getMetaSuccess } from "@App/appReducer";
import {
  CATEGORY_PAGE_SIZE,
  CATEGORY_SCOPE,
  getListingKey,
} from "@Pages/Blog/BlogHomeRevamp/settings";
import { loadFirstListingPage } from "@Pages/Blog/BlogAllPosts/data/fetchBlogListingPage";
import { setCategories } from "@Pages/Blog/BlogAllPosts/data/blogAllPostsReducer";
import fetchBlogCategories from "./fetchBlogCategories";

const getBlogCategoryData =
  ({ slug, staticContext }: { slug: string; staticContext?: any }): AppThunk =>
  async (dispatch, getState) => {
    let { categories } = getState().blogAllPostsData;
    if (!categories) {
      try {
        categories = await fetchBlogCategories();
        dispatch(setCategories(categories));
      } catch (error) {
        console.error("Error fetching blog categories:", error);
        if (staticContext) staticContext.statusCode = 500;
        return;
      }
    }

    const category = categories.find((option) => option.slug === slug);
    if (!category) {
      if (staticContext) staticContext.statusCode = 404;
      return;
    }

    const meta: any = {
      title: `${category.name} Blogs and Articles | Amber`,
      description: `${category.name} guides and articles for students, from amber.`,
      keywords: [`${category.name} student blog`, "student housing guides", "student blog"],
      canonical_url_suffix: `/blog/category/${category.slug}`,
    };
    dispatch(getMetaSuccess(meta));

    const isLoaded = await dispatch(
      loadFirstListingPage(CATEGORY_SCOPE, {
        key: getListingKey(CATEGORY_SCOPE, category.slug),
        pageSize: CATEGORY_PAGE_SIZE,
        categorySlug: category.slug,
      }),
    );
    if (staticContext && isLoaded === false) {
      staticContext.statusCode = 500;
    }
  };

export default getBlogCategoryData;
